import { atRoundEnd, cardRef, defineGameCard } from '../authoring/index.js';
import { addGrowth, alliedPlants, isLiveOnBoard, SAPLING_DEFINITION_IDS, tableOf, } from './plant-helpers.js';
/**
 * Папоротник-питомник получает Рост в конце раунда, кроме случая, когда в его
 * локации есть саженец и нет своего Листа: тогда вместо Роста создаётся Лист.
 */
export const NurseryFernCard = defineGameCard({
    id: 'nursery_fern',
    gameplay: {
        type: 'UNIT',
        cost: 2,
        baseStats: { attack: 1, health: 3 },
        traits: ['PLANT'],
    },
    presentation: {
        name: 'Папоротник-питомник',
        description: 'Фотосинтез. В конце раунда, если в этой локации есть ваш саженец и нет вашего Листа, вместо получения Роста создаёт Лист.',
        glyph: {
            colors: ['#10213A', '#9AB345', '#7D9936', '#4C6B1D', '#638028'],
            rows: [
                '....................',
                '.........11.........',
                '........1221........',
                '........1221........',
                '.......123321.......',
                '.....11233231.11....',
                '....121145551121....',
                '....122214411231....',
                '....133233435551....',
                '....1145433444111...',
                '...131114444111231..',
                '...13452244253431...',
                '....145333334551....',
                '....115443244411....',
                '...12224444432221...',
                '....154434232411....',
                '.....1454444441.....',
                '......11443411......',
                '........1321........',
                '.........11.........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        atRoundEnd({
            source: 'card_effect',
            dependencies: [
                cardRef('plant_growth'),
                cardRef('plant_leaf'),
                ...SAPLING_DEFINITION_IDS.map((id) => cardRef(id)),
            ],
            run: (ctx) => {
                const self = ctx.self;
                if (!isLiveOnBoard(self))
                    return;
                const plants = alliedPlants(ctx, self.controllerId, { tableId: tableOf(self.cellId) });
                const hasSapling = plants.some((plant) => SAPLING_DEFINITION_IDS.some((id) => id === plant.defId));
                const hasLeaf = plants.some((plant) => ctx.q.cardTraits(plant.id).includes('LEAF'));
                if (hasSapling && !hasLeaf) {
                    ctx.ops.createTokenInLocation('plant_leaf', self.controllerId, tableOf(self.cellId));
                    return;
                }
                addGrowth(ctx, self.id, 1, 'photosynthesis');
            },
        }),
    ],
    ui: { mechanics: ['growth', 'photosynthesis', 'token'] },
});
//# sourceMappingURL=nursery_fern.js.map